console.log('✅ pre-header.js loaded successfully!');

import { appState } from '../../js/state.js';
import { loadTextTranslations } from '../../js/translator.js';
import { initLinksTranslator } from '../../js/router-routes-manager.js';

//let _tempTextTranslator = null;
//export async function initTempTextTranslator(lang) {
//    _tempTextTranslator = await loadTextTranslations(lang);
//}

//let _tempLinksTranslator = null;
//export async function initTempLinksTranslator(lang) {
//    _tempLinksTranslator = await initLinksTranslator(lang);
//}

//const lang = appState.SiteLanguageCookie;
//let lang = getValidLanguageFromAppState();

export async function buildComponentPreHeader() {
  //console.log(`🔄 Building Component: buildComponentPreHeader - new test lang: ${lang}`);
  console.log(
    `🔄 Building Component: buildComponentPreHeader - new test lang x: ${appState.SiteLanguageCookie}`
  );

  //if (typeof window !== 'undefined') {
  //    await import(
  //        /* webpackChunkName: "pre-header-styles" */
  //        /* webpackPrefetch: true */
  //        "./pre-header.css"
  //    );
  //}

  try {
    //await initTempTextTranslator(appState.SiteLanguageCookie);
    //await initTempLinksTranslator(appState.SiteLanguageCookie);

    // so it ends up in its own "translation-service" chunk:
    const { loadMyTranslationsService } = await import(
      /* webpackChunkName: "my-translation-service" */
      /* webpackPrefetch: true */
      '../../services/my-translator-service.js'
    );

    // 1) Load translations in parallel (cached after first call)
    const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
      appState.SiteLanguageCookie
    );

    const {
      keyPaymentProtection: textkeyPaymentProtection,
      keyFindOutMore: textkeyFindOutMore,
    } = _tempTextTranslator;

    const { keyPaymentProtection: linkPaymentProtection } = _tempLinksTranslator;

    const html = `
           <div class="PreHeaderContainer">
           <span class="PreHeaderTitle"><a href="${linkPaymentProtection}"><b>${textkeyPaymentProtection}</b> ${textkeyFindOutMore}</a> </span>
           </div>
        `;

    console.log('✅ Pre-header built successfully.');

    return html;
  } catch (err) {
    console.error('❌ Error building pre-header:', err);
    return '<div>Pre-header could not be loaded.</div>';
  }
}

export async function initComponentPreHeader() {}
